import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layout, PageHeader } from "../components/Layout";
import { DogCard } from "../components/DogCard";
import { ProductCard } from "../components/ProductCard";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Favorites() {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  const [data, setData] = useState({ dogs: [], products: [] });
  useEffect(() => {
    if (!loading && !user) nav("/login");
    if (user) api.get("/favorites").then((r) => setData(r.data));
  }, [user, loading, nav]);
  const empty = data.dogs.length + data.products.length === 0;
  return (
    <Layout>
      <PageHeader label="Saved" title="Your Favorites" />
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-10">
        {empty ? <div className="text-center py-24 text-eon-muted border border-eon-border">Nothing saved yet.</div> : (
          <div className="space-y-12">
            {data.dogs.length > 0 && <div><h2 className="eon-heading text-2xl uppercase mb-6">Dogs</h2><div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">{data.dogs.map((d, i) => <DogCard key={d.id} dog={d} index={i} />)}</div></div>}
            {data.products.length > 0 && <div><h2 className="eon-heading text-2xl uppercase mb-6">Products</h2><div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">{data.products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}</div></div>}
          </div>
        )}
      </div>
    </Layout>
  );
}
